import { render } from "./LeftPanel.vue?vue&type=template&id=80b35500"
import script from "./LeftPanel.vue?vue&type=script&lang=js"
export * from "./LeftPanel.vue?vue&type=script&lang=js"
script.render = render

export default script